<template lang="pug">
  .event-sessions
    div(v-for="session in sessions" :key="session.id")

      h3.event-session-date(v-if="session.title") {{ session.title }}
      .event-session
        //- ph15～ オフライン/オンラインが混在する場合のみアイコンを表示
        template(v-if="event.providingType === 3")
          .session-offline(v-if="session.providingType === 1") {{$t("オフライン")}}
          .session-online(v-if="session.providingType === 2") {{$t("オンライン")}}
        //- 予約済みなら予約IDを表示する
        .session-reserve-id(v-if="session.participant")
          | {{$t("予約ID")}}：
          span {{ session.participant.reservationID }}
        dl.session-info
          //- 予約なしの場合は開催時間を表示する
          template(v-if="session.reservationType === 0")
            dt {{$t("開催時間")}}
            dd {{ session.startDateTime | moment('HH:mm') }}〜{{ session.endDateTime | moment('HH:mm') }}
          template
            dt {{$t("定員")}}
            dd(v-if="session.capacity") {{ session.capacity }}
              span(v-if="session.entryUnitType == 2") {{$t("チーム単位")}}
              span(v-else) {{$t("名様")}}
            dd(v-else) {{$t("制限なし")}}
          //- 予約開始前の場合のみ「予約開始」を表示する
          template(v-if="session.reservationStartDateTime && now < session.reservationStartDateTime")
            dt {{$t("予約開始日時")}}
            dd {{ session.reservationStartDateTime | moment('YYYY.MM.DD(ddd) HH:mm') }}
          //- 予約終了
          template(v-if="session.reservationEndDateTime")
            dt {{$t("予約終了日時")}}
            dd {{ session.reservationEndDateTime | moment('YYYY.MM.DD(ddd) HH:mm') }}

        .reserve-button-area(v-if="$store.state.user.authenticated && session.button")
          template(v-if="session.button.url")
            //- 予約が外部サイトの場合
            a._button(:href="session.button.url" target="_blank")
              span {{$t(session.button.label)}}
          template(v-else)
            button._button(v-if="session.button.onClick" :class="session.button.className" @click="session.button.onClick" :value="session.id")
              span._term(v-if="session.button.showTerm") {{ session.startDateTime | moment('HH:mm') }}〜{{ session.endDateTime | moment('HH:mm') }}
              span {{$t(session.button.label)}}
            button._button(v-else :class="session.button.className" :value="session.id")
              span._term(v-if="session.button.showTerm") {{ session.startDateTime | moment('HH:mm') }}〜{{ session.endDateTime | moment('HH:mm') }}
              span {{$t(session.button.label)}}

          transition(name="fade")
            //- Warningテキストエリア
            .reserve-event-status-block(v-show="warningText[session.id]") {{ warningText[session.id] }}
    Questions(v-show="event.questions" ref="questions" :questions="event.questions" @reserve="requestReservation")
</template>
<script>
import moment from 'moment-timezone'
import Questions from '@/components/Event/Questions'

export default {
  components: {
    Questions,
  },
  props: ['event'],
  data() {
    return {
      sessions: [],
      now: 0,
      warningText: {},
    }
  },
  watch: {
    event() {
      this.init()
    },
  },
  methods: {
    init() {
      this.now = moment().valueOf()
      this.event = this.$props.event
      this.sessions = this.parseSessions(this.event.sessions)
    },
    parseSessions(sessions) {
      sessions.map(session => {
        if (session.reservationType !== 0) {
          // 0:予約なし 1:予約あり 2:外部予約
          session.button = this.switchButtonData(session)
        }
      })
      return sessions
    },
    isOneDaySession(session) {
      return moment(session.startDateTime).isSame(
        moment(session.endDateTime),
        'day'
      )
    },
    switchButtonData(session) {
      /*
        ※※labelを変える場合はlang.jsonも変更すること※※
      */
      let button = {}
      const now = this.now
      const isOneDaySession = this.isOneDaySession(session)

      if (session.endDateTime <= now) {
        // 開催終了後なら開催終了ボタン
        button = {
          className: 'disabled',
          showTerm: false,
          label: '開催終了',
        }
        return button
      }

      if (session.participant) {
        // 予約済みならキャンセルボタン
        button = {
          className: 'cancel',
          showTerm: isOneDaySession, // セッションの開催日が1日の場合は表示
          label: 'キャンセルする',
          onClick: this.cancelReservation,
        }
        return button
      }

      /*
      Session型 ph15～ ※一部抜粋
      |`providingType`|Integer|必須|提供タイプ<br>`1`:オフライン<br>`2`:オンライン|
      |`reservationType`|Integer|必須|予約タイプ<br>`0`:予約なし<br>`1`:予約あり<br>`2`:外部予約|
      |`isFullyReserved`|Boolean|条件付き必須|外部予約が満席か否か<br>`true`:満席<br>`reservationType: 2`の場合は必須、それ以外はなし|
      |`url`|Boolean|条件付き必須|`reservationType: 2`の場合に外部予約URLが必須で返る|
      */
      if (session.reservationType === 2) {
        // 2:外部予約
        // 外部予約の場合
        if (session.isFullyReserved) {
          button = {
            className: 'active', // 満席でもactiveかつリンクありの仕様
            showTerm: isOneDaySession,
            label: '満席になりました',
            url: session.url,
          }
        } else {
          button = {
            className: 'active',
            showTerm: false,
            label: '予約は外部サイトへ',
            url: session.url,
          }
        }
        return button
      } else if (
        now < session.reservationStartDateTime ||
        session.reservationEndDateTime <= now
      ) {
        // 予約期間より前か後ならdisabled
        button = {
          className: 'disabled',
          showTerm: isOneDaySession,
          label: '予約する',
        }
        return button
      } else {
        // 予約期間内
        if (session.reservedCount >= session.capacity) {
          // 定員に達している
          button = {
            className: 'disabled',
            showTerm: isOneDaySession,
            label: '満席',
          }
        } else {
          button = {
            className: 'active',
            showTerm: isOneDaySession,
            label: '予約する',
            onClick: this.reserve,
          }
        }
        return button
      }
    },
    reserve(e) {
      console.log('予約処理開始')
      const sessionID = e.target.value
      if (this.event.hasQuestions) {
        // 予約前アンケートを開く
        this.$refs.questions.open(sessionID)
      } else {
        this.requestReservation(sessionID)
      }
    },
    requestReservation(sessionID, answers) {
      this.$emit('showLoading')
      console.log(sessionID, answers)
      let errorText = ''
      this.api(
        'reserveEvent',
        { eventID: this.event.id, sessionID, body: answers },
        rv => {
          console.log(rv.reservationID)
          if (rv.succeed) {
            errorText = '予約が完了しました'
            this.$store.commit('event/resetItems')
            this.$store.commit('reservingEvent/resetItems')
          } else {
            const errors = {
              reservationNotAccepted: 'このイベントは現在予約できません',
              alreadyReserved: '予約済です',
              reservationCapacityOver: '定員に達してるため予約できませんでした',
              reservedAnotherSession: '他のセッションに既に予約済です',
            }
            errorText = errors[rv.errorCode] || '予約に失敗しました'
          }
          this.$emit('init') // 親のinit()で再描画する
          this.warningText[sessionID] = this.$i18n.t(errorText)
        }
      )
    },
    cancelReservation(e) {
      this.$emit('showLoading')
      console.log('予約キャンセル処理開始')
      const sessionID = e.target.value
      let errorText = ''
      this.api(
        'cancelEventReservation',
        { eventID: this.event.id, sessionID },
        rv => {
          console.log(rv)
          if (rv.succeed) {
            errorText = 'キャンセルを受け付けました'
            this.$store.commit('event/resetItems')
            this.$store.commit('reservingEvent/resetItems')
          } else {
            const errors = {
              cancellationNotAccepted: 'このイベントは現在キャンセルできません',
              noReservation: '予約がないか既にキャンセル済です',
            }
            errorText = errors[rv.errorCode] || 'キャンセルに失敗しました'
          }
          this.$emit('init') // 親のinit()で再描画する
          this.warningText[sessionID] = this.$i18n.t(errorText)
        }
      )
    },
    // recordParticipation(eventID, sessionID) {
    //   //イベント予約用API(テスト用なので後日削除)
    //   this.api('recordParticipation', { eventID, sessionID }, rv => {
    //       console.log(rv)
    //   })
    // }
  },
  mounted() {
    this.init()
    //this.test_parseSessions()

    //- イベント予約用関数
    //- this.recordParticipation('b00ec20d-e929-11eb-ac47-0af363eb5062', '1800')
  },
}
</script>

<style lang="scss" scoped>
/* セッション一覧 */
.event-sessions {
  .event-sessions-by-day {
    margin-bottom: 40px;
  }
  .event-session-date {
    margin: 0 0 16px;
    height: 20px;
    padding-left: 12px;
    border-left: 3px $tags-color-blue solid;
    font-size: 16px;
    color: #222;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
  .event-session {
    margin-bottom: 16px;
    padding: 16px;
    border-radius: 6px;
    border: $tags-color-blue 1px solid;
    background: #fff;
  }

  .session-offline,
  .session-online {
    height: 36px;
    background-image: url('../../assets/images/event/offline.svg');
    background-size: 36px 36px;
    background-repeat: no-repeat;
    padding-left: 45px;
    margin-bottom: 12px;
    color: $tags-color-blue;
    font-size: 14px;
    font-weight: bold;
    line-height: 34px;
  }
  .session-online {
    background-image: url('../../assets/images/event/online.svg');
  }
  .session-reserve-id {
    border: 1px solid $tags-color-gray;
    padding: 10px 10px;
    font-size: 13px;
    font-weight: 500;
    color: $base-color;
    margin-bottom: 10px;
    border-radius: 4px;
    text-align: center;
    span {
      margin-right: 1em;
    }
  }

  .session-info {
    dt {
      min-width: 5em;
      clear: left;
      float: left;
      margin-right: 5px;
      margin-bottom: 5px;
      font-size: 12px;
      color: #999;
    }
    dd {
      margin-bottom: 5px;
      font-size: 13px;
      font-weight: 500;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.reserve-event-status-block {
  font-size: 14px;
  margin-top: 8px;
  color: $base-color-red;
}
.event-end-block {
  margin-bottom: 25px;
}

.reserve-button-area {
  margin-top: 16px;
  ._button {
    font-size: 14px;
    font-weight: 500;
    height: 48px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $tags-color-blue;
    color: #fff;
    padding: 0 28px;
    border-radius: 24px;
    text-decoration: none;
    @include link-hover();
    &:has(._term) {
      justify-content: space-between;
    }
    &.cancel {
      background-color: #f2f2f7;
      color: $base-color;
    }
    &.disabled {
      background-color: #f2f2f7;
      color: $gray-color;
      transition: none;
      cursor: default;
      opacity: 1;
    }
    span {
      pointer-events: none;
    }
  }
}
</style>
